import React, { useEffect, useState } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Drawer } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { DataGrid, esES, GridToolbar } from "@mui/x-data-grid";
import EsqueletoCargando from "../../../componentes/EsqueletoCargando";
import axios from "../../../helpers/API";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import CustomSwitch from "form/CustomSwitch";
import MsgConfirmacion from "componentes/MsgConfirmacion";
import MsgGenericoAlerta from "componentes/MsgGenericoAlerta";
import RolesForm from "./RolesForm";
import TablaMaterialUI from "componentes/TablaMaterialUI";

const useStyles = makeStyles((theme) => ({
  cardCrear: {
    height: 120,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      cursor: "pointer",
    },
  },
  inputNuevaBanda: {
    width: "100%",
  },
}));

function RolesLista({ keyLista, setKeyLista }) {
  const classes = useStyles();
  const [drawer, setDrawer] = React.useState(false);
  const [cargando, setCargando] = React.useState(true);
  const [roles, setRoles] = useState([]);
  const [editando, setEditando] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [idMenu, setIdMenu] = React.useState(null);

  // MODALS
  const [modalExito, setModalExito] = useState(false);
  const [msgExito, setMsgExito] = useState("");
  const [tituloExito, setTituloExito] = useState("");
  const [modalError, setModalError] = useState(false);
  const [msgError, setMsgError] = useState("");

  const [modalResetContraseña, setModalResetContraseña] = useState(false);

  const [modalBorrar, setModalBorrar] = useState(false);
  const [idRolBorrar, setIdRolBorrar] = useState();
  const mostrarModalBorrar = (id) => {
    setModalBorrar(true);
    setIdRolBorrar(id);
  };

  //MENU TABLA
  const handleClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setIdMenu(id);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIdMenu(null);
  };

  useEffect(() => {
    getRoles();
  }, []);

  const getRoles = () => {
    setCargando(true);
    setRoles([]);
    axios
      .post("/seguridad/rol/listar", {})
      .then(function (response) {
        if (!response.data.error) {
          setRoles(response.data);
          setCargando(false);
        } else {
          // updateMessage(response.data.msg, true);
        }
      })
      .catch(function (error) {
        // console.log(error);
        // updateMessage("Ha ocurrido un error al traer los datos", true);
      });
  };

  const cambiarEstado = (id, checked) => {
    axios
      .post(checked ? "/seguridad/rol/activar" : "/seguridad/rol/desactivar", {
        id: id,
      })
      .then(function (response) {
        if (!response.data.error) {
          //   updateMessage("Se ha " + action + " el usuario correctamente", false);
        } else {
          //   updateMessage("Fallo el " + action + " de este usuario", true);
        }
      })
      .catch(function (error) {
        console.log(error);
        // updateMessage("Fallo el " + action + " de este usuario", true);
      })
      .finally(function () {
        setRoles([]);
        getRoles();
      });
  };

  const borrarRol = (id) => {
    setTituloExito("Borrar Rol");

    if (id) {
      axios
        .post("/seguridad/rol/eliminar", { id: id })
        .then(function (response) {
          setModalBorrar(false);
          setModalExito(true);
          if (!response.data.error) {
            setMsgExito("Se ha eliminado el rol correctamente");
            getRoles();
          } else {
            setMsgExito(response.data.msg);
          }
        })
        .catch(function (error) {
          setMsgExito("Ha ocurrido un error");
        });
    }
  };

  const columns = [
    {
      field: "id",
      hide: true,
    },
    {
      field: "nombre",
      headerName: "Nombre",
      editable: false,
      flex: 0.2,
    },
    {
      field: "activado",
      headerName: "Estado",
      editable: false,
      flex: 0.2,
      renderCell: (data) => (
        <CustomSwitch
          checked={data.row.activado}
          hook={(flag) => cambiarEstado(data.row.id, flag)}
        />
      ),
    },
    {
      headerName: "Tareas",
      flex: 0.2,
      field: "tareas",
      renderCell: (params) => (
        <>
          <Button
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={(e) => handleClick(e, params.row.id)}
          >
            Ver Tareas
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={idMenu == params.row.id}
            onClose={handleClose}
          >
            <MenuItem
              onClick={() => {
                handleClose();
                setDrawer(true);
                setEditando({ id: params.row.id });
              }}
            >
              Ver/Editar
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleClose();
                mostrarModalBorrar(params.row.id);
              }}
            >
              Borrar
            </MenuItem>
          </Menu>
        </>
      ),
    },
  ];

  return (
    <Grid container spacing={2}>
      {modalBorrar && (
        <MsgConfirmacion
          setVisible={setModalBorrar}
          titulo="Borrar Rol"
          msg={"¿Desea borrar el rol seleccionado?"}
          aceptar={() => borrarRol(idRolBorrar)}
        />
      )}
      {modalExito && (
        <MsgGenericoAlerta
          setVisible={setModalExito}
          titulo={tituloExito}
          msg={msgExito}
        />
      )}

      <Drawer
        className={classes.drawerBanda}
        anchor="right"
        open={drawer}
        onClose={() => setDrawer(false)}
      >
        <RolesForm drawer={setDrawer} editando={editando} getRoles={getRoles} />
      </Drawer>
      <Grid item md={9}>
        <Card style={{ height: 120, width: "100%" }}>
          <CardContent>
            <Typography variant="h5">Roles</Typography>
            {/* <Typography>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse bibendum orci sed elit congue ultrices.
            </Typography> */}
          </CardContent>
        </Card>
      </Grid>
      <Grid item md={3}>
        <Card
          elevation={6}
          className={classes.cardCrear}
          onClick={() => {
            setDrawer(true);
            setEditando(false);
          }}
        >
          <CardContent>
            <Typography variant="h5">Crear</Typography>
            {/* <Typography>Lorem ipsum dolor</Typography> */}
          </CardContent>
        </Card>
      </Grid>
      <Grid item md={12}>
        <Card>
          <div style={{ height: 400, width: "100%" }}>
            <TablaMaterialUI
              columnas={columns}
              filas={roles}
              cargando={cargando}
              sortModel={{
                field: "id",
                sort: "desc",
              }}
            />
          </div>
        </Card>
      </Grid>
    </Grid>
  );
}
export default RolesLista;
